<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">废弃管理</span>
      <router-link to='/Warehouse/DiscardExport' class="btn-scan ivu-btn ivu-btn-primary fr">导入废弃单</router-link>
    </div>
    <!-- <div class="tr mb10">
      <button class="ivu-btn ivu-btn-primary" @click="exportData">下载数据</button>
    </div> -->
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        客户编号
        <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户编号" />
        状态
        <Select v-model="screen_data.status" style="width: 200px;" class='ml10 mr20 w200'>
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
        废弃单号
        <Input class='ml10 mr20 w200' v-model="screen_data.discard_bill_no" placeholder="请输入废弃单号" />
      </div>
      <div class="search-item">

        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      <template slot-scope="{ row, index }" slot="oprate">
        <a @click="getDetail(row.discard_bill_no)" class="blue mr10">查看详情</a>
        <a v-if="row.status == 10 || row.status == 20" @click="cancel(row.discard_bill_no)" class="blue mr10">取消</a>
      </template>
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal title="查看详情" v-model="show_detail" width="1000">
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        is_preview: localStorage.getItem("is_preview") == 'true' ? true : false, //是否打印预览
        show_detail: false,
        detailInfo: {},
        outPrintData: {}, //出库单数据
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: 10,
          label: '待打印'
        }, {
          value: 20,
          label: '待废弃'
        }, {
          value: 30,
          label: '待支付'
        }, {
          value: 40,
          label: '已完成'
        }, {
          value: '-10',
          label: '已取消'
        }],
        detail_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 200,
          tooltip: true,
        }, {
          title: '商品名称',
          key: 'product_name',
          tooltip: true,
          width: 200
        },{
          title: '所在包裹',
          key: 'package_no',
          tooltip: true,
          width: 200
        }, {
          title: '数量',
          key: 'total_count',
        }],
        detail_list: [],

        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        date: '', //当前日期:时分秒
      }
    },
    methods: {
      getDetail(discard_bill_no) {
        this.$axios.get("/WarehouseDiscard/bill/detail?discard_bill_no=" + discard_bill_no).then(res => {
          if (res.success && res.data) {
            this.detail_list = res.data
          } else {
            this.detail_list = []
          }
        })

        this.show_detail = true
      },
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      //取消废弃单
      cancel(discard_bill_no) {
         this.$Modal.confirm({
             title: '取消废弃单',
             content: '<p>确定要取消单号为“'+ discard_bill_no + '”的废弃单吗 </p><p>此操作将无法撤回！</p>',
             onOk: () => {
                 this.$axios.put("/WarehouseDiscard/bill/cancel?discard_bill_no=" + discard_bill_no).then(res => {
                   if (res.success) {
                     this.$Message.success('取消成功');
                     this.getList()
                   }
                 })
             },
             onCancel: () => {

             }
         });
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/WarehouseDiscard/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData(out_bill_no) {
        this.$axios.get("/WarehouseOut/bill/detail/export/excel", {
          params: {
            out_bill_no: out_bill_no
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '废弃单号',
          key: 'discard_bill_no',
          tooltip: true,
          minWidth: 170,
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 80,
        }, {
          title: '客户姓名',
          key: 'client_name',
          tooltip: true,
          minWidth: 120,
        }, {
          title: 'SKU数',
          key: 'sku_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '状态',
          key: 'salePrice',
          minWidth: 80,
          render: (h, params) => {
            let status = params.row.status;
            let color = '';
            let txt = '';
            if (status == 10) { //待打印
              color = '#D9001B'
              txt = '待打印'
            } else if (status == 20) { // 待打包
              color = '#4acd40'
              txt = '待废弃'
            } else if (status == 30) { //待支付
              color = '#FFB800'
              txt = '待支付'
            } else if (status == 40) { //待出库
              color = '#169BD5'
              txt = '已完成'
            } else if (status == '-10') { //已取消
              color = '#333'
              txt = '已取消'
            }
            return h('span', {
              style: {
                color: color
              },
            }, txt)
          }
        }, {
          title: '更新时间',
          key: 'update_date',
          minWidth: 170,
        }, {
          title: '创建时间',
          key: 'create_date',
          minWidth: 170,
        }, {
          title: '操作',
          minWidth: 280,
          slot: 'oprate'
        }];
        return arr;
      },
    },
    created() {
      $.getScript("static/js/LodopFuncs.js", function(res) {
        checkPrintLoad(function() {
          LODOP = getCLodop();
        })
      })
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      this.screen_data.biz_type = 1;
      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style scoped>
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/yikuhuanbiao/discard/list.vue